export default import.meta.ROLLDOWN_FILE_URL_4PlVoPtcCtPBpDBdewCL1Q